module.exports = __webpack_public_path__ + "static/remote-ux-bf30cf03815bad82c14c1f62c919d400.png";